import { render, staticRenderFns } from "./FormTechnologicalDevelopmentsCategory.vue?vue&type=template&id=65cca8b5&scoped=true&"
import script from "./FormTechnologicalDevelopmentsCategory.vue?vue&type=script&lang=js&"
export * from "./FormTechnologicalDevelopmentsCategory.vue?vue&type=script&lang=js&"
import style0 from "./FormTechnologicalDevelopmentsCategory.vue?vue&type=style&index=0&id=65cca8b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cca8b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextField})
